var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactsBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.42704626334519574 0 0 0.42704626334519574 0 4.270462633451956)"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M290.8 66.9c87.1-57.4 209.5-45.7 286.5 39.5 42.1 46.6 59.2 110.7 102.9 156.3 49.2 51.3 108 101.2 130.3 171.2 23.7 74.4 2.9 159.7-50.1 216.6-64.5 69.2-159.3 48.4-248.9 47.3-366.9-4.6-639.6-249.5-292.6-551.4 29-25.4 43.1-60.6 71.9-79.5z",
    fill: "#dfeedd",
    className: "svgShape colorcce9ff-0 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M616 281H499c-6.6 0-12-5.4-12-12v-76c0-6.6 5.4-12 12-12h117c6.6 0 12 5.4 12 12v76c0 6.6-5.4 12-12 12z",
    fill: "#ffffff",
    className: "svgShape colorffffff-1 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M480.6 195.1v75.1c0 10.4 8.4 18.8 18.8 18.8H612c10.4 0 18.8-8.4 18.8-18.8v-75.1c0-10.4-8.4-18.8-18.8-18.8H499.4c-10.4 0-18.8 8.4-18.8 18.8zm9.8 77c-.1-.6-.4-1.2-.4-1.8v-75.1c0-1 .3-1.9.6-2.7l39.7 34.1-39.9 45.5zM612 185.7c.6 0 1.2.2 1.8.4l-58.1 49.8-58.1-49.8c.6-.1 1.1-.4 1.8-.4H612zm-30.9 40.7 39.7-34.1c.3.9.6 1.8.6 2.7v75.1c0 .7-.2 1.2-.4 1.8l-39.9-45.5zm-81.7 53.2c-1 0-1.8-.3-2.7-.5l40.7-46.5 15.2 13.1c.9.8 2 1.1 3.1 1.1s2.2-.4 3.1-1.1l15.2-13.1 40.7 46.5c-.9.3-1.7.5-2.7.5H499.4z",
    fill: "#94c78d",
    className: "svgShape colorffbe55-2 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M673 496h-88c-6.6 0-12-5.4-12-12v-55.4c0-6.6 5.4-12 12-12h88c6.6 0 12 5.4 12 12V484c0 6.6-5.4 12-12 12z",
    fill: "#ffffff",
    className: "svgShape colorffffff-3 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M569.8 427.3v59.4c0 8.2 6.6 14.9 14.9 14.9h89.1c8.2 0 14.9-6.6 14.9-14.9v-59.4c0-8.2-6.6-14.9-14.9-14.9h-89.1c-8.2.1-14.9 6.7-14.9 14.9zm7.7 60.9c-.1-.5-.3-.9-.3-1.5v-59.4c0-.8.2-1.5.4-2.2L609 452l-31.5 36.2zm96.3-68.3c.5 0 .9.2 1.4.3l-45.9 39.4-45.9-39.4c.5-.1.9-.3 1.4-.3h89zm-24.5 32.2 31.4-26.9c.2.7.4 1.4.4 2.2v59.4c0 .5-.2 1-.3 1.5l-31.5-36.2zm-64.6 42c-.8 0-1.4-.2-2.1-.4l32.2-36.8 12.1 10.3c.7.6 1.6.9 2.4.9.9 0 1.7-.3 2.4-.9l12.1-10.3 32.2 36.8c-.7.2-1.4.4-2.1.4h-89.2z",
    fill: "#72b569",
    className: "svgShape color2a94f4-4 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M716.4 182.4v40.2c0 5.6 4.5 10.1 10.1 10.1h60.3c5.6 0 10.1-4.5 10.1-10.1v-40.2c0-5.6-4.5-10.1-10.1-10.1h-60.3c-5.6 0-10.1 4.5-10.1 10.1zm5.3 41.2c-.1-.3-.2-.6-.2-1v-40.2c0-.5.1-1 .3-1.5l21.3 18.2-21.4 24.5zm65.1-46.2c.3 0 .6.1.9.2l-31.1 26.7-31.1-26.7c.3-.1.6-.2.9-.2h60.4zm-16.5 21.8 21.3-18.2c.1.5.3.9.3 1.5v40.2c0 .3-.1.7-.2 1l-21.4-24.5zm-43.8 28.4c-.5 0-1-.1-1.4-.3l21.8-24.9 8.2 7c.5.4 1.1.6 1.6.6.6 0 1.2-.2 1.6-.6l8.2-7 21.8 24.9c-.5.1-.9.3-1.4.3h-60.4z",
    fill: "#dfeedd",
    className: "svgShape colorcce9ff-5 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M733 390h-36c-6.6 0-12-5.4-12-12v-21.4c0-6.6 5.4-12 12-12h36c6.6 0 12 5.4 12 12V378c0 6.6-5.4 12-12 12z",
    fill: "#ffffff",
    className: "svgShape colorffffff-6 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M683.5 351.6v31.2c0 4.3 3.5 7.8 7.8 7.8h46.8c4.3 0 7.8-3.5 7.8-7.8v-31.2c0-4.3-3.5-7.8-7.8-7.8h-46.8c-4.3.1-7.8 3.5-7.8 7.8zm4.1 32c-.1-.3-.2-.5-.2-.8v-31.2c0-.4.1-.8.2-1.1l16.5 14.1-16.5 19zm50.5-35.8c.3 0 .5.1.7.1l-24.1 20.7-24.1-20.7c.2 0 .5-.1.7-.1h46.8zm-12.9 16.8 16.5-14.1c.1.4.2.7.2 1.1v31.2c0 .3-.1.5-.2.8l-16.5-19zm-33.9 22.1c-.4 0-.8-.1-1.1-.2l16.9-19.3 6.3 5.4c.4.3.8.5 1.3.5s.9-.2 1.3-.5l6.3-5.4 16.9 19.3c-.4.1-.7.2-1.1.2h-46.8z",
    fill: "#94c78d",
    className: "svgShape colorffbe55-7 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M612.4 94.6V127c0 4.5 3.6 8.1 8.1 8.1H669c4.5 0 8.1-3.6 8.1-8.1V94.6c0-4.5-3.6-8.1-8.1-8.1h-48.5c-4.4 0-8.1 3.6-8.1 8.1zm4.3 33.2c-.1-.3-.2-.5-.2-.8V94.6c0-.4.1-.8.2-1.2l17.1 14.7-17.1 19.7zm52.4-37.2c.3 0 .5.1.8.2l-25 21.5-25-21.5c.3-.1.5-.2.8-.2h48.4zm-13.3 17.5 17.1-14.7c.1.4.2.8.2 1.2V127c0 .3-.1.5-.2.8l-17.1-19.7zM620.5 131c-.4 0-.8-.1-1.2-.2l17.5-20 6.6 5.6c.4.3.8.5 1.3.5s.9-.2 1.3-.5l6.6-5.6 17.5 20c-.4.1-.7.2-1.2.2h-48.4z",
    fill: "#72b569",
    className: "svgShape color2a94f4-8 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M528.2 292.3h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 531.2,
    cy: 295.3,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-10 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M518.7 297.4h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 521.7,
    cy: 300.4,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-12 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M509.4 302.8h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 512.4,
    cy: 305.8,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-14 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M501.9 310.5h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 504.9,
    cy: 313.5,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-16 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M495.5 319.1h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 498.5,
    cy: 322.1,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-18 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M490.6 328.7h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 493.6,
    cy: 331.7,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-20 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M487.5 339h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 490.5,
    cy: 342,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-22 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M544.7 381.5h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 547.7,
    cy: 384.5,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-24 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M533.9 381.5h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 536.9,
    cy: 384.5,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-26 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M523.1 381.5h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 526.1,
    cy: 384.5,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-28 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M512.3 381.5h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 515.3,
    cy: 384.5,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-30 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M501.5 381.5h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 504.5,
    cy: 384.5,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-32 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M669.7 364.1h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 672.7,
    cy: 367.1,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-34 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M658.9 363.8h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 661.9,
    cy: 366.8,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-36 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M648.1 363.5h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 651.1,
    cy: 366.5,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-38 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M637.6 366.1h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 640.6,
    cy: 369.1,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-40 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M627.2 369h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 630.2,
    cy: 372,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-42 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M618.3 375h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 621.3,
    cy: 378,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-44 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M610.2 382h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 613.2,
    cy: 385,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-46 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M603.7 390.6h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 606.7,
    cy: 393.6,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-48 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M599.1 400.3h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 602.1,
    cy: 403.3,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-50 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M720 239.1h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 723,
    cy: 242.1,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-52 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M711.1 245.3h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 714.1,
    cy: 248.3,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-54 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M701.2 249.4h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 704.2,
    cy: 252.4,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-56 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M691.1 253.3h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 694.1,
    cy: 256.3,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-58 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M680.6 255.6h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 683.6,
    cy: 258.6,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-60 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M670 257.7h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 673,
    cy: 260.7,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-62 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M659.2 258.6h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 662.2,
    cy: 261.6,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-64 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M648.4 259h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 651.4,
    cy: 262,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-66 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M637.6 258.7h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 640.6,
    cy: 261.7,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-68 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M596.8 112.5h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 599.8,
    cy: 115.5,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-70 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M586.4 115.3h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 589.4,
    cy: 118.3,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-72 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M577.8 121.6h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 580.8,
    cy: 124.6,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-74 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M571.4 129.9h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 574.4,
    cy: 132.9,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-76 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M567.6 140h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 570.6,
    cy: 143,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-78 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M566.4 150.7h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 569.4,
    cy: 153.7,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-80 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M567.2 161.5h6v6h-6z",
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 570.2,
    cy: 164.5,
    r: 3,
    fill: "#4f8f47",
    className: "svgShape color6b6b6b-82 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M395.8 702c.8-.3 1.5-.5 2.3-.8 0 0-.3-.6-.8-1.8-8.2-17-76.4-151.4-207.9-177.2-1-.2-2.1-.4-3.1-.6-16.7-3-34.3-4.3-52.9-3.4 0 0-26.1.5-58.2 23.1-.7.5-1.4 1-2.2 1.5-14.4 10.5-29.9 25.6-44.8 47l-.9 1.2s.2.6.7 1.7c4.6 10.6 31.4 67.1 94.8 104.2.8.5 1.7 1 2.5 1.4 57.5 32.9 144.2 49.5 270.5 3.7z",
    fill: "#2d5229",
    className: "svgShape color0b4870-83 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m397.8 702.6.3-1.4.3-1.4-1.1-.3L28.2 590l-.9 1.2s.2.6.7 1.7L395.8 702l2 .6z",
    fill: "#ffffff",
    className: "svgShape colorffffff-84 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m125.4 698.6 55.1-61.8-1.8-2.2-55.8 62.6c.8.5 1.6.9 2.5 1.4zM247.9 656.7l3.1.4-61.6-134.8c-1-.2-2.1-.4-3.1-.6l61.6 135zM109.7 616.7l2.2-1.4-36.8-73.9c-.7.5-1.4 1-2.2 1.5l36.8 73.8z",
    fill: "#ffffff",
    className: "svgShape colorffffff-85 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m390.6 696.1 1.2.9s.2-.4.7-1c6.4-10.1 55.4-92.3 24.7-171.6-.2-.6-.5-1.3-.7-1.9-4-10-9.3-19.9-16.1-29.6 0 0-9.1-13.8-32.1-23.4-.5-.2-1-.4-1.6-.6-10.5-4.2-23.9-7.4-40.4-8.1h-1s-.2.3-.7 1c-4.1 6-25.4 39.5-23.8 86.2 0 .6 0 1.2.1 1.8 1.9 41.9 22.4 94 89.7 146.3z",
    fill: "#72b569",
    className: "svgShape color2a94f4-86 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m391 697.4.9-.3.9-.3-.2-.7L326.3 461h-1s-.2.3-.7 1l66 234.3.4 1.1z",
    fill: "#ffffff",
    className: "svgShape colorffffff-87 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m300.9 549.8 51.8 8.7.5-1.7-52.5-8.8c.1.6.1 1.2.2 1.8zM364.9 601.4l.8 1.8 51.5-78.7c-.2-.6-.5-1.3-.7-1.9l-51.6 78.8zM339.5 513.7l1.5.7 27.2-44.8c-.5-.2-1-.4-1.6-.6l-27.1 44.7z",
    fill: "#ffffff",
    className: "svgShape colorffffff-88 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M391.4 701.5c.7.1 1.4.1 2 .2v-1.5c0-14.8-3.1-132.9-93.9-196.1-.7-.5-1.4-1-2.2-1.5-11.6-7.8-24.6-14.8-39.1-20.5 0 0-20.1-8.6-52.7-3.6-.7.1-1.5.2-2.2.3-14.8 2.5-32.1 7.8-51.2 17.8-.4.2-.7.4-1.1.6 0 0 0 .5-.1 1.5-.4 9-.5 58 34.4 105.9.5.6.9 1.2 1.4 1.9 31.8 42.6 91.9 84 204.7 95z",
    fill: "#94c78d",
    className: "svgShape colorffbe55-89 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m392.7 702.6.7-.9.7-.9-.7-.6-241.3-203.6c-.4.2-.7.4-1.1.6 0 0 0 .5-.1 1.5l240.4 202.8 1.4 1.1z",
    fill: "#ffffff",
    className: "svgShape colorffffff-90 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m186.7 606.4 64.4-24.7-.6-2.2-65.2 25c.5.7.9 1.3 1.4 1.9zM295.3 618.8l2.2 1.4 2.1-116.2c-.7-.5-1.4-1-2.2-1.5l-2.1 116.3zM204.5 543.3l2.2-.2-1.2-64.7c-.7.1-1.5.2-2.2.3l1.2 64.6z",
    fill: "#ffffff",
    className: "svgShape colorffffff-91 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m449.7 707.3-3.7 29-12.5 4.5 3.3-34.8zM392.7 707.3l-3.7 29-12.5 4.5 3.3-34.8z",
    fill: "#95c88e",
    className: "svgShape colordba17b-92 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m408.9 348.5-19.7 25.1 18.8 10.2 21.1-26.1z",
    fill: "#85bf7e",
    className: "svgShape colorcc9271-93 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M459.4 350.3c-.6-3.8-1-7.7-1.3-11.6-.2-3.1-.1-6.2 0-9.3.3-3.1.3-6.2.1-9.1 0 .1-.1.2-.1.3-.2-2.6-.6-5.2-1.3-7.7-2-6.3-6.1-12.2-12.5-14.4-12.8-4.3-28.4 7.7-34.9 26.9s-1.4 38.3 11.4 42.6c9.1 3.1 19.6-2.1 27.2-12.2 3-.1 6-.3 8.9-1.1 1-.3 2-.7 2.5-1.6.3-.9.2-1.9 0-2.8z",
    fill: "#95c88e",
    className: "svgShape colordba17b-94 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M470 318.7c4.1-1.4 7.6-4.9 8.4-9.1.8-4.3-1.6-9.1-5.7-10.5-3.1-1.1-6.8-.2-9.6-1.8-1.7-1-2.8-2.7-4-4.2-6.6-8.4-17.5-13.2-28.1-12.4-10.6.8-20.7 7.1-26 16.3-4.5 7.8-5.6 17.1-4.8 26 .8 8.9 3.5 17.6 6.1 26.1 4.4-8.7 8.8-17.4 13.2-26 1-1.9 2-3.9 3.8-5 1.8-1.1 4.6-1 5.6.8.7 1.2.5 2.7.5 4 0 1.4.2 3 1.4 3.6 1.3.7 3-.1 4.2-1 2.6-1.9 4.9-4.2 7-6.7 1.3-1.6 2.6-3.6 4.5-4.4 2.1-.9 3.9.1 5.8 1.2 2.6 1.5 5.3 2.9 8.3 3.5 3.1.6 6.4.6 9.4-.4zM456.8 500.6c3.9 25 7.6 68.5 11.5 93.5 5.7 36.7-12.4 91.6-19.1 128.1-4.9-.6-9.2-2.1-14.1-2.7 1.6-61.9-1.2-140.8-5.2-202.6 8.7 1.1 18.2-17.4 26.9-16.3z",
    fill: "#2d5229",
    className: "svgShape color0b4870-95 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M396.1 518c5.1.3 10.1-4.3 15.2-3.9 6.2.4 12.9 1.6 18.8 3.4 5.9 1.8 12.8-3.7 18.6-5.7 1.2 10-.9 27.8-2.8 37.7-4.4 23.2-9.5 46.2-15.4 69-3.2 12.6-12.7 24.7-17.7 36.7-2.1 5.1-4.1 10.4-6 15.6-4 10.8-10.9 41.2-14.9 52-4.9-.4-9.9-.5-14.8-.9.5-10.9 4.8-42.3 5.2-53.2.8-18.2 9.9-37.3 17.1-54.1-3.6-17.4-3.7-36.3-3.6-54.1.1-15.7.2-26.9.3-42.5z",
    fill: "#396733",
    className: "svgShape color0e538c-96 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M465.2 450.8c1.8.3 3.9.2 5.3-1 .7-.6 1.2-1.5 1.7-2.2 1.7-2 4.6-3 7.1-2.4 5.2 1.3 7.7 7.9 12.9 9 .8.2 1.6.2 2.4.5.8.3 1.5.8 1.6 1.6.2 1-.5 1.8-1.2 2.6-.9 1-1.9 2-2.8 3-.4.4-.9.9-1.4 1.1-1.1.5-2.5 0-3.4.7-.8.6-1 1.8-1.9 2.4-1.3.8-3.1-.4-4.6.2-.8.3-1.3 1-1.9 1.4-1.1.7-2.6.6-3.9.2-1.3-.5-2.4-1.3-3.5-1.9-1.5-.8-3.1-1.4-4.7-1.9-4.4-1.1-9.1-.8-13.7-.4-.2-3.6-.3-7.2-.5-10.8 0-.6 0-1.3.3-1.9.6-1.1 2.2-1.1 3.5-.8 1.6.4 2.4.3 3.9 0s3.3.4 4.8.6z",
    fill: "#95c88e",
    className: "svgShape colordba17b-97 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M477 464.6c-.5-.8-.3-1.9.5-2.4l28.8-19c.8-.5 1.9-.3 2.4.5s.3 1.9-.5 2.4l-28.8 19c-.8.5-1.9.3-2.4-.5z",
    fill: "#2d5229",
    className: "svgShape color0b4870-98 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M454 721.3c.4-.9 1.5-1.2 2.2-.6 3.1 2.6 11.4 8.5 27.9 12.3 0 0 4 .8 6.9 5.5h-61.2v-10.8c0-1.2 1.4-1.8 2.3-1.1l2.4 2c1.1 1 2.6 1.5 4 1.5l8.8.1c1.9 0 3.6-1.1 4.3-2.9l2.4-6z",
    fill: "#dfeedd",
    className: "svgShape colorcce9ff-99 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M429.9 738.5h61.2v6.3h-61.2z",
    transform: "rotate(-180 460.485 741.664)",
    fill: "#396733",
    className: "svgShape color0e538c-100 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M394.2 724.7c.6-.7 1.8-.6 2.3.2 2 3.5 7.9 11.8 22 21.1 0 0 3.5 2.2 4.7 7.5l-57.6-20.7 3.7-10.2c.4-1.1 1.9-1.3 2.5-.2l1.5 2.7c.7 1.3 1.9 2.3 3.3 2.8l8.2 3c1.8.7 3.8.1 5-1.3l4.4-4.9z",
    fill: "#dfeedd",
    className: "svgShape colorcce9ff-101 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M362.8 742.9H424v6.3h-61.2z",
    transform: "rotate(-160.203 393.322 746.107)",
    fill: "#396733",
    className: "svgShape color0e538c-102 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M454.9 445.7c4.4 14.7 7.7 37.8 9.8 53 .5 3.6.2 17.2-2.3 19.8-1.5 1.6-40.2 5.9-56.3 11.2-2.2.7-12.7 4.8-14.8 3.9-3-1.3-4.6-14.5-3.9-17.6 9.3-40.1 9.3-10.6-4.3-89.5-2.7-15.8-7.9-30.4-2.5-45.5 1.8-5 15.4-19.6 15.4-19.6s4.6 4.9 9.3 7.7c3.9 2.3 9 6.4 12.3 7.2 15.1 3.5 32 51.7 37.3 69.4z",
    fill: "#72b569",
    className: "svgShape color2a94f4-103 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M436.2 552.7c1.3 2.8 1.9 5.9 2.2 8.9.4 5.3-.2 10.6-1.7 15.6-2.2-.5-4-2.5-4.3-4.8 1 1.6.1 4-1.7 4.5s-3.8-1.2-3.7-3.1c-.5 1.6-2.3 2.8-3.9 2.5-1.7-.3-3-1.9-2.9-3.6.7.5.5 1.7-.1 2.2-.7.5-1.7.4-2.4 0s-1.2-1.2-1.5-2c-.5-1.4-.7-2.9-.8-4.4-.5-6.4-.9-12.9-1.4-19.3-.1-.9-.1-1.8.3-2.6.8-1.5 2.9-1.7 4.7-1.6l6.9.3c1.5.1 3.1 0 4.5.5 2.5 1.2 4.6 4.5 5.8 6.9z",
    fill: "#95c88e",
    className: "svgShape colordba17b-104 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M411.2 402.5c-.8 13.5-1.6 27.1-2.5 40.6-.5 7.5-.9 15.1.2 22.5.9 6.2 2.8 12.2 4.7 18.1 6.9 21.4 13.8 42.8 20.8 64.2-7.4-.5-14.9-1-22.3-1.5-5.9-22.9-17.3-63.8-18.3-67.5-8.2-25.7-11.1-53-8.5-79.8l25.9 3.4z",
    fill: "#72b569",
    className: "svgShape color2a94f4-105 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M377 271c0-26.5-29.1-48-65-48s-65 21.5-65 48 29.1 48 65 48c6.8 0 13.4-.8 19.5-2.2L355 336v-29c13.5-8.8 22-21.7 22-36z",
    fill: "#94c78d",
    className: "svgShape colorffbe55-106 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M339.5 224.5c0-21.5-23.6-39-52.8-39s-52.8 17.4-52.8 39c0 21.5 23.6 39 52.8 39 5.5 0 10.9-.6 15.9-1.8l19 15.6v-23.5c11-7.3 17.9-17.7 17.9-29.3z",
    fill: "#ffffff",
    className: "svgShape colorffffff-107 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M314 210.5h-57c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h57c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zM314 221.3h-57c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h57c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zM314 232.2h-57c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h57c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zM314 243h-57c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h57c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z",
    fill: "#94c78d",
    className: "svgShape colorffbe55-108 selectable"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsBlack);
export default __webpack_public_path__ + "static/media/contactsBlack.34408ec741631ef9588c69c502614706.svg";
export { ForwardRef as ReactComponent };